import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * Soundium custom inventory status.
 * Mirrors Horizon's native <product-inventory> (4.x): on a variant change the
 * variant picker dispatches a ProductSelectEvent carrying a promise that
 * resolves with the refetched section HTML; we grab our counterpart from that
 * HTML and morph ourselves in place. (Horizon 3.x used ThemeEvents.variantUpdate,
 * which no longer exists in 4.1.1 — SND-11425.)
 */
class SoundiumInventoryStatus extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * Handles product select event by updating the stock status.
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const updated = html.querySelector('soundium-inventory-status');
        if (!updated) return;

        morph(this, updated, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[soundium-inventory-status] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('soundium-inventory-status')) {
  customElements.define('soundium-inventory-status', SoundiumInventoryStatus);
}
